let authConfig = {
  // wx 授权
  cookiesPrefix: 'tencent_health_', // 写到前端的cookie前缀
  scope: 'snsapi_base',
  componentIdGetter: () => {
    // 根据本次请求获取对应componentId，componentId与authRedirectUri一一对应
    return 'wxffb507d905139a33'
  },
  appidGetter: () => {
    // 根据本次请求获取对应appid
    return 'wx6961bc0d34055450' // 腾讯健康
  },
  authorizeWhiteList: [
    '/favicon.ico'
  ],
  getOpenidWhiteList: [// 指定哪些path是不需要获取openid
    '/favicon.ico'
  ],
  authRedirectUri: 'https://mpauth.wecity.qq.com/mpauth/directopenid',
  authFailCallback: (ctx) => {
    ctx.status = 403
    ctx.body = {
      code: '-1000',
      message: 'wx-auth failure'
    }
  }
}

module.exports = authConfig
